import { useState } from 'react';

const replyToEmail = 'info@stargiga.ae';

/** Display overrides only where the key should read nicer than auto-formatting */
const FIELD_LABELS = {
	formSource: 'Submitted from',
};

/** Turn camelCase / snake_keys into readable email labels */
function formatFieldLabel(rawKey) {
	if (FIELD_LABELS[rawKey] !== undefined) return FIELD_LABELS[rawKey];
	const spaced = String(rawKey)
		.replace(/_/g, ' ')
		.replace(/([a-z])([A-Z])/g, '$1 $2')
		.trim();
	return spaced.replace(/\b\w/g, (c) => c.toUpperCase());
}

function escapeHtml(text) {
	return String(text)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

function generateTextContent(formData, replyEmail) {
	let content = Object.entries(formData)
		.map(([key, value]) => `${formatFieldLabel(key)}: ${value}`)
		.join('\n');

	content += `\n\n---\nPlease reply to: ${replyEmail}`;
	return content;
}

function generateHtmlContent(formData, replyEmail) {
	return `
      <h2>New Form Submission</h2>
      ${Object.entries(formData)
				.map(([key, value]) => `<p><strong>${escapeHtml(formatFieldLabel(key))}:</strong> ${escapeHtml(value)}</p>`)
				.join('')}
      <hr />
      <p style="font-size: 12px; color: #666;">If you'd like to respond to this email, please reply to: <a href="mailto:${replyEmail}">${replyEmail}</a></p>
    `;
}

/** Use from class components or anywhere outside React hooks */
export async function sendContactEmail(formData, emailSubject, customTemplate = null) {
	try {
		const response = await fetch('https://email-nodejs-fawn.vercel.app/api/send-email', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				emailConfig: {
					host: 'rcp2.mywebsitebox.com',
					port: 465,
					user: 'noreply@stargiga.ae',
					pass: '$Kh4Q41r%i,G?pE?',
					from: 'StarGiga <noreply@stargiga.ae>',
				},
				emailData: {
					to: 'info@stargiga.ae',
					from: {
						name: 'Stargiga',
						email: 'noreply@stargiga.ae',
					},
					sender: {
						name: 'Stargiga',
						email: 'noreply@stargiga.ae',
					},
					replyTo: replyToEmail,
					headers: {
						'Reply-To': replyToEmail,
						'Return-Path': replyToEmail,
						From: 'StarGiga<noreply@stargiga.ae>',
					},
					subject: emailSubject,
					text: generateTextContent(formData, replyToEmail),
					html: customTemplate || generateHtmlContent(formData, replyToEmail),
				},
			}),
		});

		if (response.ok) {
			return { ok: true };
		}
		let message = 'Failed to submit. Please try again.';
		try {
			const errorData = await response.json();
			if (errorData.message) message = errorData.message;
		} catch (_) {
			/* non-JSON body */
		}
		return { ok: false, error: message };
	} catch (err) {
		return { ok: false, error: 'Network error. Please try again later.' };
	}
}

const EmailSender = () => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [succeeded, setSucceeded] = useState(false);
	const [error, setError] = useState(null);

	const sendEmail = async (formData, emailSubject, customTemplate = null) => {
		setIsSubmitting(true);
		setError(null);

		try {
			const result = await sendContactEmail(formData, emailSubject, customTemplate);
			if (result.ok) {
				setSucceeded(true);
				return true;
			}
			setError(result.error || 'Failed to submit. Please try again.');
			return false;
		} finally {
			setIsSubmitting(false);
		}
	};

	return {
		isSubmitting,
		succeeded,
		error,
		sendEmail,
		setSucceeded,
		setError,
	};
};

export default EmailSender;
